/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineConfiguration {
    getFixupPrototypeFunction() { return TagBaselineConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineConfiguration>): TagBaselineConfiguration {
        let obj = Object.assign(new TagBaselineConfiguration(), model);
        TagBaselineConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineConfiguration>): TagBaselineConfiguration {
        if (!model) return null;
        return TagBaselineConfiguration.newInstance(<TagBaselineConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineConfiguration) {
        if (!obj) return;

        models.TagBaselineConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineConfiguration): boolean {
        Object.setPrototypeOf(obj, TagBaselineConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let key in this.tags) {
                let val = this.tags[key];
                if (val) {
                    models.TagBaselineRule.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Tag rules in this baseline
     */
    tags: { [key: string]: models.TagBaselineRule; };

}
